import * as getters from "../../baseQuestion/checkbox/store/getters";
import * as mutations from "../../baseQuestion/checkbox/store/mutations";
import * as actions from "../../baseQuestion/checkbox/store/actions";
import { state as base_state } from "../../baseQuestion/checkbox/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_arts"
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
